import React, { useState } from 'react'
import { toast } from '@CommonComponents/toast'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { canvasConnect as endpoints } from '@URLS'
import { setPosting, setPosted } from '../App'
import { inCanvas } from './ConfigDeepLinksPage'
import { ItemsSelected } from '../base_comps/ItemsSelected'

export const SelectedSectionsContainer = () => {
  const [currentState, dispatch] = useStateValue()
  const [currentSect, setCurrentSect] = useState(0)
  let params = window.location.pathname.split('/')
  let coursenum = params[3]
  let contextId = params[4]

  const postSelectedSections = async (
    bookSects,
    selectedSects,
    inCanvasSects,
    contextId,
    coursenum,
    setPosting,
    setPosted,
    dispatch,
    useNewTab=true
  ) => {
    await dispatch({
      type: 'linksPosting',
      payload: true,
    })
    setPosting(true, dispatch)
    let sects = []
    bookSects.map(chap => {
      chap[1].forEach(sect => {
        if (selectedSects.includes(sect.secId)) {
          let canvasData = inCanvas(sect.secId, inCanvasSects)
          sect['canvasId'] = canvasData[0] && canvasData[1]
          sects.push(sect)
        }
      })
    })
    for (let i = 0; i < sects.length; i++) {
      let data = {
        contextId: contextId,
        selectedSection: sects[i],
        coursenum: coursenum,
        useNewTab: useNewTab
      }
      try {
        setCurrentSect(i + 1)
        await client.post(endpoints.postDeepLinks(), data)
      } catch (err) {
        setPosted(true, dispatch)
        toast.error('There was an error configuring the deep links in Canvas.')
      }
    }
    try {
      let resp = await client.get(
        endpoints.getDeepLinkInfo({
          coursenum: coursenum,
          contextId: contextId,
        })
      )
      dispatch({
        type: 'inCanvasSections',
        inCanvasSections: resp.data.inCanvas,
      })
    } catch (err) {
      setPosted(true, dispatch)
      toast.error('There was an error updating which sections are in Canvas')
    }
    setPosted(true, dispatch)
    setPosting(false, dispatch)
  }

  const resetSelected = (dispatch, setPosted) => {
    dispatch({
      type: 'sectionSelection',
      selectedSections: [],
    })
    setPosted(false, dispatch)
  }

  return (
    <React.Fragment>
      <div className="mb-4">
        <ItemsSelected
          items={currentState.selectedSections}
          currentItem={currentSect}
          contentCategory="Reading"
          contentType="section"
          postItems={postSelectedSections}
          postParams={[
            currentState.bookSections,
            currentState.selectedSections,
            currentState.inCanvasSections,
            contextId,
            coursenum,
            setPosting,
            setPosted,
            dispatch,
          ]}
          resetFunc={resetSelected}
          resetParams={[dispatch, setPosted]}
          posting={currentState.linksPosting}
          posted={currentState.linksPosted}
        />
      </div>
    </React.Fragment>
  )
}
